import { Reveal, SectionHead } from "./shared";

const STEPS = [
    { num: "01", title: "Tell Us About Your Business", desc: "We learn your services, customers, processes, FAQs, and goals." },
    { num: "02", title: "We Build Your Automation", desc: "We connect your forms, CRM, calendar, messaging, follow-ups, and AI workflows." },
    { num: "03", title: "Your AI Starts Working", desc: "Your system begins responding, following up, booking appointments, and organizing leads." },
];

export default function HowItWorks() {
    return (
        <section id="how-it-works" className="py-24 sm:py-32" data-testid="how-it-works-section">
            <div className="container-x">
                <SectionHead
                    eyebrow="07 — Process"
                    title="From Setup to Automation in 3 Simple Steps."
                    testid="how-it-works-heading"
                />
                <div className="mt-16 relative">
                    <div className="hidden md:block absolute top-8 left-[16%] right-[16%] h-px bg-gradient-to-r from-cyan-400/10 via-cyan-400/40 to-cyan-400/10" />
                    <div className="md:hidden absolute left-8 top-8 bottom-8 w-px bg-gradient-to-b from-cyan-400/40 via-cyan-400/10 to-transparent" />
                    <div className="grid md:grid-cols-3 gap-10 md:gap-6">
                        {STEPS.map((s, i) => (
                            <Reveal key={s.num} delay={i * 0.15}>
                                <div className="relative flex md:flex-col items-start md:items-center gap-6 md:text-center" data-testid={`how-it-works-step-${s.num}`}>
                                    <div className="shrink-0 w-16 h-16 rounded-2xl glass flex items-center justify-center relative z-10">
                                        <span className="ff-display text-xl font-black text-gradient">{s.num}</span>
                                    </div>
                                    <div className="md:mt-4 md:px-4">
                                        <h3 className="text-xl font-bold text-white tracking-tight">{s.title}</h3>
                                        <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
